module.exports = __webpack_public_path__ + "static/media/success.67e2abe4.svg";